




























import { Component, Vue, Watch } from "vue-property-decorator";
import { State, namespace } from "vuex-class";

import { Evidence } from "@/types";
import AuthPanel from "@/components/AuthPanel.vue";
import ModeButton from "@/components/ModeButton.vue";
import DocumentForm from "@/components/DocumentForm.vue";
import ComputedTime from "@/components/ComputedTime.vue";
import EvidencesList from "@/components/EvidencesList.vue";
import CombinedDocument from "@/components/CombinedDocument.vue";

const { throttle } = require("lodash");

const Evidences = namespace("evidences");

@Component({
  components: {
    CombinedDocument,
    EvidencesList,
    AuthPanel,
    ComputedTime,
    ModeButton,
    DocumentForm
  }
})
export default class LiveView extends Vue {
  @State("raw")
  private text!: string;

  @Evidences.Getter("sorted")
  private evidences!: Evidence[];

  @Evidences.Action("update")
  encode!: () => Promise<void>;

  update = throttle(() => {
    this.encode();
  }, 500);
}
